import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "login",

    component: () =>
      import(
        "@/components/Login.vue"
      ) /*import( /* webpackChunkName: "about"  './Login.vue')*/
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("@/components/Dashboard.vue"),
    children: [{
        path: "vendas",
        component: () => import("../views/Vendas.vue")
      },
      {
        path: 'compras',
        component: () => import('../views/Compras.vue')
      },
      {
        path: "saidas",
        component: () => import("../views/Xml.vue")
      },
      {
        path: "entradas",
        component: () => import("../views/Entradas.vue")
      },
      {
        path: "eventos",
        component: () => import("../views/Eventos.vue")
      },
      {
        path: "inutilizadas",
        component: () => import("../views/Inutilizadas.vue")
      },
      {
        path: "produtos_sgt",
        component: () => import("../views/ProdutosSgt.vue")
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;